import { render, staticRenderFns } from "./HomeBannerFooter.vue?vue&type=template&id=50cf547e&scoped=true&"
import script from "./HomeBannerFooter.vue?vue&type=script&lang=js&"
export * from "./HomeBannerFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeBannerFooter.vue?vue&type=style&index=0&id=50cf547e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf547e",
  null
  
)

component.options.__file = "HomeBannerFooter.vue"
export default component.exports